const roundToTwo = (num) => {
	const factor = 10 ** 2
	return Math.round(+num * factor) / factor
}

export default roundToTwo
